import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { Trans } from "@lingui/react/macro";

export const Route = createFileRoute("/(protected)/_layout/admin")({
  component: AdminGuard,
});

/** Roles that belong to Yes, Chef internal staff. */
export const INTERNAL_ROLES = ["SUPER_ADMIN", "SUPPORT"] as const;

/** Returns true when the user is an internal Yes, Chef admin. */
export function useIsInternalAdmin() {
  const { hasRole } = useAuth();
  return INTERNAL_ROLES.some((role) => hasRole(role));
}

function AdminGuard() {
  const { isLoading } = useAuth();
  const isInternalAdmin = useIsInternalAdmin();

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <div className="text-(--color-text-secondary)">
          <Trans>Loading...</Trans>
        </div>
      </div>
    );
  }

  if (!isInternalAdmin) {
    return (
      <Navigate
        to="/unauthorized"
        search={{ reason: "internal_only", from: "/admin", requiredRole: "SUPER_ADMIN|SUPPORT" }}
        replace
      />
    );
  }

  return <Outlet />;
}
